/******/window.PXUTheme.jsBlog={init:function(o){
// Add settings from schema to current object
window.PXUTheme.jsBlog=$.extend(this,window.PXUTheme.getSectionData(o)),1==this.enable_filter&&$("#blog_filter").on("change",(function(){window.PXUTheme.jsBlog.blogFilter()}))},blogFilter:function(){let o=$("#blog_filter").val();window.location=o},unload:function(o){$("#blog_filter").off()}}
/******/;